import { render, staticRenderFns } from "./News__id.vue?vue&type=template&id=0015bf20&"
import script from "./News__id.vue?vue&type=script&lang=js&"
export * from "./News__id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports